/* eslint-disable no-magic-numbers */
'use strict';

const Cookies = require('js-cookie');
const uuidv4 = require('uuid/v4');

const getOrSetSessionId = () => {
    let currentSessionId = Cookies.get('bridge-sid');
    currentSessionId = currentSessionId ? currentSessionId : uuidv4();
    Cookies.set('bridge-sid', currentSessionId, { expires: 1/48 });
    return currentSessionId;
};

const getOrSetVisitorId = () => {
    let currentVisitorId = Cookies.get('bridge-vid');
    if (!currentVisitorId) {
        currentVisitorId = uuidv4();
        Cookies.set('bridge-vid', currentVisitorId, { expires: 390 });
    }
    return currentVisitorId;
};

module.exports = {
    getOrSetSessionId,
    getOrSetVisitorId
};
